import { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({ name: "", phone: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ WhatsApp with conversion tracking
  const handleWhatsapp = () => {
    const msg = `שלום, אני ${formData.name}, אשמח לקבל פרטים :)`;
    const url = `https://wa.me/972543998043?text=${encodeURIComponent(msg)}`;

    if (window.gtag_report_conversion) {
      window.gtag_report_conversion(url);
    } else {
      window.open(url, "_blank");
    }
  };

  // ✅ Email with conversion tracking
  const handleEmail = () => {
    const subject = "פניה מאתר מויאל זכוכיות";
    const body = `שם: ${formData.name}\nטלפון: ${formData.phone}`;
    const mailto = `mailto:moyalglass@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    if (window.gtag_report_conversion) {
      window.gtag_report_conversion(mailto);
    } else {
      window.location.href = mailto;
    }
  };

  return (
    <section
      id="contact"
      dir="rtl"
      className="flex justify-center items-center py-24 bg-transparent"
    >
      <div className="glass-card border-gradient animated glow w-[400px] max-w-[92vw] p-10 text-slate-100">
        <h2 className="text-2xl font-bold mb-2 text-center text-slate-100">
          השאר פרטים ונחזור אליך
        </h2>

        <p className="text-center text-slate-300 mb-8">
          מענה מהיר בוואטסאפ או במייל
        </p>

        <div className="flex flex-col gap-4">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="p-3 rounded-xl bg-slate-900/70 border border-slate-600 text-slate-100 placeholder-slate-400
                       focus:ring-4 focus:ring-amber-500/15 focus:border-amber-500 outline-none transition"
            placeholder="הכנס שם מלא"
          />

          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="p-3 rounded-xl bg-slate-900/70 border border-slate-600 text-slate-100 placeholder-slate-400
                       focus:ring-4 focus:ring-amber-500/15 focus:border-amber-500 outline-none transition"
            placeholder="הכנס מספר טלפון"
          />

          <div className="flex flex-col gap-3 mt-6">
            <button onClick={handleWhatsapp} className="btn-primary">
              שלח בוואטסאפ
            </button>

            <button onClick={handleEmail} className="btn-secondary">
              שלח במייל
            </button>
          </div>
        </div>

        {/* ✅ טלפון לחיץ + conversion */}
        <p className="text-center text-slate-300 mt-8 font-semibold">
          טלפון ישיר:{" "}
          <a
            href="tel:0543998043"
            onClick={(e) => {
              e.preventDefault();
              if (window.gtag_report_conversion) {
                window.gtag_report_conversion("tel:0543998043");
              }
            }}
            className="text-slate-100 hover:text-white transition-colors"
          >
            054-3998043
          </a>
        </p>
      </div>
    </section>
  );
}